<template>


  
<div  v-if="corporateClient == 'hoval'" class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
    <loading v-if="loadingState || loadingState2" />
<HovalEditCalc/>

</div>
<div  v-else-if="corporateClient == 'emicon'" class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
    <loading v-if="loadingState || loadingState2" />
<EmiconEditCalc/>
</div>


</template>

<script>
import { AUTH_REQUEST, AUTH_SOCIAL } from "actions/auth";
import { USER_REQUEST } from "actions/user";
import { ADD_NOTIFICATIONS, GET_NOTIFICATIONS } from "actions/notifications";

import { mapGetters, mapState } from "vuex";
import axios from "axios";
const moment = require("moment");

const numeral = require("numeral");
//import numFormat from 'vue-filter-number-format';

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";

import Vue from "vue";

// GET DOC LIST
import documents from "../../components/documents/documents.js";
import HovalEditCalc from './hovalEditCalc.vue'
import EmiconEditCalc from './emiconEditCalc.vue'

export default {
  name: "editacalc",
  components :{
    HovalEditCalc,
    EmiconEditCalc,
    FormWizard,
    TabContent,
    Datepicker,
  },
  data() {
    return {
      //  ONLY FOR EDIT *****************************
      item: {},
      // *****************************
      documents: documents,
      username: "",
      password: "",
      token: "",
      numeral: require("numeral"),
      proccess: "START",
      loading: false,
      priceAcc: "",
      corporateClient:'',
      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",
      privacyPolicy: process.env.PRIVACY,
      cookiePolicy: process.env.COOKIE,
      utilizzoPolicy: process.env.UTILIZZO,
      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: "Caldaia a condensazione",
          value: "condensazione",
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale",
        },
        2: {
          name: "Pompa di calore",
          value: "pompadicalore",
        },
        3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi",
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua",
        },
        /*5: {
          name: "Climatizzatore",
          value: "climatizzatore",
        },*/
        5: {
          name: "Collettore solare termico",
          value: "solare",
        },
        6: {
          name: "Altro Prodotto",
          value: "altroVaillant",
        },
      },
      groupsAccessori: {
        0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione",
        },
        1: {
          name: "Altro Accessorio",
          value: "altroV",
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche",
        },
        3: {
          name: "Altro materiale/valvolame",
          value: "altro",
        },
      },
      confirmed: true,
      usoAbitativo: "",
      resend_success: false,
      loadingState2: false,
      loadingState: false,

      passwordFieldType: "password",
      moment: moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [],

      accessories: [],

      quantity: "",
      finish: process.env.FINISH,
      vw: window.innerWidth,
      stepSize: "md",

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: it,
      eventStartdate: "",
      disabledDatesStart: {
        to: "",
        from: "",
      },
      allProducts: {},
      totalAccessories: "0,00",
      totalProducts: "0,00",
      enea: "",
      requiredOperations: "",
      client_type: "",
      priceEnea: 0,
      client_ownership: "Proprietario",
      totalExtraMise: 0,
      clearExtraMise: false,
      NoEnea: true,
      priceDcast: 0,

      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      selectorModPrice: "",
      age_lavoro: 0,
      age_extra: 0,
      priceNew: 0,
      pricenewFlag: false,
      costoAttualizazioneChange: false,
      serviceCostChange: false,
    };
  },

  methods: {
    keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(
            ".",
            ","
          );
        }
      }
    },
    setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text =
        "Perfetto hai scelto " +
        value +
        ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(ADD_NOTIFICATIONS, note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        this.$log("ECOBONUS => " + _vue.ecoBonus);
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        this.$log("clearExtraMise => " + _vue.clearExtraMise);
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(this.ecoBonus);

      this.$log(from + " => " + to);
    },
    checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },
    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab() {
      var _vue = this;
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });
      return this.$validator.validateAll("form-1");
    },
    validateSecondTab: function () {
      this.$log(this.$validator);
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.beginCalc("si");
          setTimeout(function () {
            if (_vue.item.costoAttualizazione != "no") {
              _vue.calcInfo.costoAttualizazione = parseFloat(
                _vue.item.costoAttualizazione
              );
              _vue.costoAttualizazioneChange = true;
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
            }
            if (_vue.item.serviceCost != "no") {
              _vue.calcInfo.serviceCost = parseFloat(_vue.item.serviceCost);
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
              _vue.serviceCostChange = true;
            }
          }, 1000);

          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });

      this.$store.dispatch(USER_REQUEST);
      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function () {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    modPrice: function (selectorModPrice) {
      var txt = "";
      txt += "<br />Importo attuale : ";
      if (selectorModPrice == "oneri") {
        txt += (
          parseFloat(this.calcInfo.allOneri) -
          parseFloat(this.calcInfo.serviceCost) *
            (1 + parseFloat(this.iva_altri_oneri))
        ).toFixed(2);

        var titleV = "Modifica importo oneri finanaziari";
      }
      if (selectorModPrice == "pratica") {
        txt += (
          parseFloat(this.calcInfo.serviceCost) *
          (1 + parseFloat(this.iva_altri_oneri))
        ).toFixed(2);

        var titleV = "Modifica importo costi gestione pratica";
      }
      txt += " €";
      var _vue = this;
      _vue.pricenewFlag = false;

      this.$swal({
        title: titleV,
        html:
          txt +
          '<br /><br /><div class="group"><lable class="niceInputLable">Importo da aggiornare :</lable><input type="number" min="0" step="0.01" id="swal-input1" placeholder = "Importo .." class="swal2-input"></div>',
        placeholder: "Importo",
        inputAttributes: {
          autocapitalize: "off",
        },
        reverseButtons: true,
        confirmButtonText: "CONTINUA",
        showCancelButton: true,
        cancelButtonText: "ANNULLA",
        cancelButtonColor: "red",
        //confirmButton: 'closeProductsModal',
        confirmButtonColor: "#b61617",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          _vue.priceNew = document.getElementById("swal-input1").value;
          _vue.priceNew = _vue.priceNew.replace(/,/g, ".");
          _vue.priceNew = _vue.priceNew.replace("€", "");
          _vue.priceNew = _vue.priceNew.replace(/\s/g, "");
          if (selectorModPrice == "pratica") {
            _vue.calcInfo.serviceCost =
              parseFloat(_vue.priceNew) /
              (1 + parseFloat(_vue.iva_altri_oneri));
            this.serviceCostChange = true;
          }

          if (selectorModPrice == "oneri") {
            _vue.calcInfo.costoAttualizazione = parseFloat(_vue.priceNew);
            this.costoAttualizazioneChange = true;
          }

          _vue.beginCalc("nopopup");
          _vue.pricenewFlag = true;
        },
      }).then((result) => {});
    },
    async prepareDocumentList() {
      // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
      this.$log("DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO");
      this.$log("client_type " + this.client_type);
      this.$log("selettore_titoloPossesso " + this.client_ownership);
      var docTemp = this.documents[this.client_type];
      this.documents[this.client_type] = {};

      var selettore_titoloPossesso = this.client_ownership;
      var selettore_enea = this.enea;

      if (selettore_enea == "0") {
        selettore_enea = "no";
      } else {
        selettore_enea = "yes";
      }

      for (var ele in docTemp) {
        if (docTemp[ele].hasOwnProperty("codice")) {
          this.documents[this.client_type][ele] = docTemp[ele];
        } else if (docTemp[ele].hasOwnProperty("selector")) {
          if (
            docTemp[ele]["selector"].hasOwnProperty(
              selettore_titoloPossesso.toLowerCase()
            )
          ) {
            var tmpList =
              docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
          } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
            var tmpList =
              docTemp[ele]["selector"][selettore_enea.toLowerCase()];
          }
          for (var eleS in tmpList) {
            this.documents[this.client_type][eleS] = tmpList[eleS];
          }
        }
      }

      var docsFinal = this.documents[this.client_type];
      var docHtml =
        '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
      var i = 1;
      for (var x in docsFinal) {
        var obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";
        docHtml =
          docHtml +
          "<tr> <th>" +
          i +
          '</th><th align="left"> ' +
          docsFinal[x].name +
          "</th><th> " +
          obl +
          "</th></tr>";
        i = i + 1;
      }
      docHtml = docHtml + "</tbody></table>";
      return docHtml;

      //****************************************************************************************************
    },
    async onComplate() {
      this.loadingState = true;

      //var docsFinal = await this.prepareDocumentList()
      var docsFinal = "";
      // PREPARE DATA TO POST
      var data = {};
      // PASS DOC LIST
      data.docs = docsFinal;

      /////// NEW *******************************************************************
      data.oldItem = this.item;
      data.serviceCost = this.serviceCostChange
        ? this.calcInfo.serviceCost
        : "no";
      data.costoAttualizazione = this.costoAttualizazioneChange
        ? this.calcInfo.costoAttualizazione
        : "no";
      /////// NEW *******************************************************************

      // ALL USER DATA
      data.user = this.getProfile;
      this.$error(data.user);
      // BONUS SELECTED
      data.bonus = this.ecoBonus;
      // CLIENT DATA
      data.client_name = this.clientName;
      data.client_lastname = this.clientLastname;
      data.client_type = this.client_type;

      data.client_mobile = this.client_mobile;
      data.client_phone = this.client_phone;
      data.client_email = this.client_email;

      // NEWWWWWWWWW
      if (this.zeroEnea) {
        data.client_price_enea = this.zeroEneaOld;
      } else {
        data.client_price_enea = this.priceEnea;
      }

      // NEWWWWWWWWW 2
      if (this.zeroDcast) {
        data.client_price_dcast = this.zeroDcastOld;
      } else {
        data.client_price_dcast = this.priceDcast;
      }

      // CLIENT HOUSE DATA
      data.building_province = this.province;
      data.building_city = this.city.city;
      data.building_zip = this.zip;
      data.building_address = this.adress;
      data.building_civic = this.civic;
      // TO GET CADASTRAL DATA ?
      data.to_get_cadastral_data = this.datiCatastali;
      // INTERVENTION DATA
      data.intervention_type = this.eventType;
      data.intervention_date = moment(this.eventStartdate).format("YYYY-MM-DD");
      // PRODUCTS & ACCESSORIES
      data.products = this.products;
      data.accessories = this.accessories;
      data.enea_request = this.enea;
      data.created_at = moment().format("YYYY-MM-DD HH:mm:00");
      data.created_date = moment().format("DD-MM-YYYY HH:mm");

      // CASH VALUES
      data.total_product_price = this.totalProducts;
      data.total_accessories_price = this.totalAccessories;
      data.price_work = this.priceWork;

      data.total_transfer_for_user = this.calcInfo.aInstallatore;
      data.total_transfer_for_client = this.calcInfo.finalPrice;
      data.total_bonus_savings = this.calcInfo.totalWithBonus;

      data.total_work_and_iva = this.calcInfo.totalBaseAndIva;

      // HTML FOR PDF
      data.htmlInvoice = this.$refs.invoiceData.innerHTML;
      //requiredOperations: '',
      data.building_uso_abitativo = this.usoAbitativo;

      data.client_ownership = this.client_ownership;

      data.iva_altri_oneri = this.iva_altri_oneri;
      data.iva_accessori_lavoro = this.iva_accessori_lavoro;
      data.iva_age_extra = this.iva_age_extra;
      data.iva_age_lavoro = this.iva_age_lavoro;
      data.iva_age_accessori = this.iva_age_accessori;

      axios({
        url: process.env.ROOT_API + "api/editPriceQuotation",
        method: "POST",
        data: data,
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          var alert = {};
          alert.text = "Il tuo preventivo è stato modificato!";
          alert.type = "SUCCESS";
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "success",
            title: "Preventivo modificato",
            html: alert.text,
          });
          this.loadingState = false;

          this.$router.push("/offerte");
        })
        .catch((resp) => {
          this.$swal({
            type: "error",
            title: "Ops....",
            html: "Riprova più tardi",
          });
          this.loadingState = false;
        });
    },

    // MAIN CALC ***************************************************************
    beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        //this.calcInfo.serviceCost = 160
        this.calcInfo.serviceCost = process.env.PRACTIC_PRICE;
      }
      //var AttPercent = 10.58
      var AttPercent = process.env.FINANCE_COST;

      var totProducts = parseFloat(
        this.totalProducts.replace(".", "").replace(",", ".")
      ).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (
        parseFloat(totProducts.replace(",", ".")) -
        parseFloat(totalExtraMise.replace(",", "."))
      ).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(
        this.totalAccessories.replace(".", "").replace(",", ".")
      ).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(
        this.priceWork.replace(".", "").replace(",", ".")
      ).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(
        2
      );
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (
        parseFloat(totAge) + parseFloat(totAltroAcc)
      ).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = (
          parseFloat(totAltroAcc) * this.iva_accessori_lavoro +
          parseFloat(totAge) * this.iva_age_lavoro
        ).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (
          parseFloat(this.age_extra) * this.iva_age_extra
        ).toFixed(2);
        this.calcInfo.iva22NonAge = (
          parseFloat(totalExtraMise) * this.iva_altri_oneri
        ).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)

        // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)

      } else {

        //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)

        // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)

      }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
        temp = 0.0;
      }

      this.$log("age_lavoro - " + this.age_lavoro);
      this.$log("iva_age_lavoro - " + this.iva_age_lavoro);
      this.$log("age_extra - " + this.age_extra);
      this.$log("iva_age_extra - " + this.iva_age_extra);
      this.$log("totAltroAcc - " + totAltroAcc);
      this.$log("totAltroAcc - " + this.iva_accessori_lavoro);

      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)
      this.calcInfo.totalBaseAndIva =
        parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) +
        parseFloat(this.age_extra) * (1 + parseFloat(temp)) +
        parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(
        this.calcInfo.totalBaseAndIva
      ).toFixed(2);

      // TOTALE DETRAZIONE
      if (
        this.ecoBonus != "Bonus Casa 50%" &&
        this.client_type == "Partita IVA" &&
        this.usoAbitativo == 0 &&
        this.iva_age_lavoro == "0.22" &&
        this.iva_age_extra == "0.22" &&
        this.iva_accessori_lavoro == "0.22"
      ) {
        this.calcInfo.totalWithBonus =
          (parseFloat(this.calcInfo.totalBase) / 100) *
          parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus =
          (parseFloat(this.calcInfo.totalBaseAndIva) / 100) *
          parseFloat(percentbonusDetr);
      }

      this.calcInfo.totalWithBonus = parseFloat(
        this.calcInfo.totalWithBonus
      ).toFixed(2);

      this.calcInfo.total35 =
        (parseFloat(this.calcInfo.totalBaseAndIva) / 100) *
        parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione =
          (parseFloat(this.calcInfo.totalWithBonus) / 100) * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(
          this.calcInfo.costoAttualizazione
        ).toFixed(2);
      }

      this.calcInfo.allOneri =
        parseFloat(this.calcInfo.costoAttualizazione) +
        parseFloat(this.calcInfo.serviceCost) +
        parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast =
          process.env.PRICE_DCAST * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (
          parseFloat(this.calcInfo.totalBaseAndIva) -
          parseFloat(this.calcInfo.totalWithBonus) +
          (parseFloat(totalExtraMise) +
            parseFloat(this.calcInfo.iva22NonAge) +
            parseFloat(this.calcInfo.iva10NonAge) +
            parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) *
              (parseFloat(this.iva_altri_oneri) + 1) +
            parseFloat(this.priceDcast) *
              (parseFloat(this.iva_altri_oneri) + 1) +
            parseFloat(this.calcInfo.allOneri))
        ).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (
          parseFloat(this.calcInfo.totalBaseAndIva) -
          parseFloat(this.calcInfo.totalWithBonus) +
          (parseFloat(totalExtraMise) +
            parseFloat(this.calcInfo.iva22NonAge) +
            parseFloat(this.calcInfo.iva10NonAge) +
            parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) +
            parseFloat(this.priceDcast) +
            parseFloat(this.calcInfo.allOneri))
        ).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea =
          process.env.PRICE_ENEA * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (
        parseFloat(this.calcInfo.totalWithBonus) -
        parseFloat(this.calcInfo.costoAttualizazione) -
        dEnea -
        dCast
      ).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(
        2
      );
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text =
            "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text =
            "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text =
            "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text =
            "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text =
            "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;
        var haveCondensed = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text =
              "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(ADD_NOTIFICATIONS, alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text,
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {
      }
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },

    // ADD REMOVE ITEMS ***************************************************************
    addProduct() {
      var count = this.products.length;

      if (count) {
        this.productIndex = this.productIndex + 1;
      }

      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false,
      });
    },
    removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories() {
      var count = this.accessories.length;

      if (count) {
        this.accessoriesIndex = this.accessoriesIndex + 1;
      }

      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false,
      });
    },
    removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },

    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    },
    handleResize: function () {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function () {
      const { provincies, provinciesState } = this;
      axios({
        url: process.env.ROOT_API + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false;
        })
        .catch((resp) => {
          this.provincies = [];
          this.provinciesState = false;
        });
    },
    checkProvince: function () {
      const { province } = this;
      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function () {
      const { city } = this;
      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork() {
      this.priceWork = numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea() {
      this.priceEnea = numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast() {
      this.priceDcast = numeral(this.priceDcast).format("0.0,[00]");
    },
    // PRODUCTS ***************************************************************
    loadProducts() {
      if(this.corporateClient){
      var data = {
        key: "calc",
        cc : this.corporateClient
      }
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        url: process.env.ROOT_API + "api/getProducts",
        method: "POST",
        data: {
          data
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.allProducts = resp.data.allProducts;
          this.$log(this.allProducts);
        })
        .catch((resp) => {});
        }else{
        this.setProfile()
      }
    },
     setProfile: function () {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if(this.corporateClient) this.loadProducts()

    },
    setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = "";
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = numeral(this.products[i].price).format(
        "0.0,[00]"
      );
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct(index) {
      this.$log(1);
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(
          this.allProducts[this.products[i].group][
            this.products[i].product.index
          ].PotenzaPompadiCalore
        ).toFixed(2);

        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        this.$log("START LOAD IBRIDE");

        this.$log(this.products[i]);
        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione =
          this.allProducts[this.products[i].group][
            this.products[i].product.index
          ].ModelloCaldaiaACondensazione;
        var pompadicalore =
          this.allProducts[this.products[i].group][
            this.products[i].product.index
          ].ModelloPompaDiCalore;
        this.$log("condensazione => " + condensazione);
        this.$log("pompadicalore => " + pompadicalore);

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          this.$log(
            this.allProducts["condensazione"][x].Modello + " = " + condensazione
          );
          if (
            this.allProducts["condensazione"][x].Modello.includes(condensazione)
          ) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (
            this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)
          ) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (
          this.products[i].group == "pompadicalore" &&
          (this.province == "AL" ||
            this.province == "AT" ||
            this.province == "BI" ||
            this.province == "CN" ||
            this.province == "NO" ||
            this.province == "TO" ||
            this.province == "VB" ||
            this.province == "VC")
        ) {
          var canUseInPiemonte =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].Piemonte;
          this.$warn(
            "GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " +
              canUseInPiemonte
          );
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text =
              "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(ADD_NOTIFICATIONS, alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text,
            });
          }
        }
        // SET requiredOperations
        if (
          this.products[i].group == "pompadicalore" ||
          this.products[i].group == "condensazione" ||
          this.products[i].group == "ibridi" ||
          this.products[i].group == "tradizionale"
        ) {
          this.requiredOperations =
            "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
         // this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = true;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].onlyBonusCasa;
          this.$warn(
            "GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa
          );
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text =
              "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(ADD_NOTIFICATIONS, alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text,
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (
          this.products[i].group != "condensazione" &&
          this.products[i].group != "ibridi" &&
          this.products[i].group != "solare" &&
          this.products[i].group != ""
        ) {
          var alert = {};
          alert.text =
            "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        } else {
          this.requiredOperations =
            " - Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        /*
        if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/

        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations =
            " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations =
            " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {
      }
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (
        this.eventType == "Instalazione" &&
        this.ecoBonus == "Bonus Casa 50%"
      ) {
        if (this.products[i].group != "solare") {
          this.warning1();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group == "condensazione") {
          this.warning2();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "solare") {
          this.warning15();
        }
      }

      if (this.eventType != "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group == "climatizzatore") {
          this.warning16();
        }
      }

      if (this.ecoBonus != "Bonus Casa 50%") {
        this.$warn("CHECK climatizzatore USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "climatizzatore") {
          var onlyBonusCasa =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].onlyBonusCasa;
          this.$warn(
            "GROUP => climatizzatore AND onlyBonusCasa: " + onlyBonusCasa
          );
          if (onlyBonusCasa == "yes") {
            this.warning162();
          }
        }
      }
    },
    warning162() {
      var _vue = this;
      var alert = {};
      this.$log("INSIDE 162");
      alert.text =
        "Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
      alert.type = "ERROR";
      setTimeout(function () {
        _vue.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text,
        });
      }, 1000);
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
    },
    warning16() {
      var alert = {};
      alert.text =
        "Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },
    warning15() {
      var alert = {};
      alert.text =
        "Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },
    warning2() {
      var alert = {};
      alert.text =
        "Con Ecobonus 50% non è consentita la nuova installazione di apparecchi";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },
    warning1() {
      var alert = {};
      alert.text =
        "Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },
    insertProductCode(input) {
      var i = input.slice(7, input.length);
      this.$log(i);
      var _vue = this;

      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on",
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: async (searchItem) => {
          var result = await this.searchProduct(searchItem, i, input);
          var length = searchItem.length;

          if (length != 10) {
            this.$swal.showValidationMessage(
              `Codice Prodotto ${"deve essere composto da 10 caratteri"}`
            );
            return false;
          }

          if (result) {
            _vue.checkProductWithBonusRules(input);
            return result;
          } else {
            //throw new Error('Prodotto non trovato')
            this.$swal.showValidationMessage(` ${"Prodotto non trovato"}`);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        this.calcTotalPriceProducts();
      });
    },
    async searchProduct(searchItem, index, input) {
      var data = this.allProducts;
      for (var x in data) {
        for (var y in data[x]) {
          if (data[x][y].codice.includes(searchItem)) {
            //0010014674
            this.items[input] = this.allProducts[x];

            this.products[index].group = x;
            var z = {
              index: y,
              name: data[x][y].Modello,
              serial: data[x][y].codice,
            };
            this.products[index].product = z;
            this.products[index].quantity = 1;
            //this.products[index].price = data[x][y].prezzo

            return data[x][y];
          }
        }
      }
    },
    calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        //new
        this.calcMaxPriceByKW(this.products[x].index);

        price +=
          this.products[x].quantity *
          parseFloat(
            this.products[x].price.replace(".", "").replace(",", ".")
          ).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise =
            parseFloat(this.totalExtraMise) +
            parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE " + this.totalExtraMise);
    },
    calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;

      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(
              2
            );
            var res = (
              parseFloat(price) / parseFloat(kw.replace(",", "."))
            ).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 600
              ).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(
              2
            );
            var res = (
              parseFloat(price) / parseFloat(kw.replace(",", "."))
            ).toFixed(2);
            if (
              res > 1300 &&
              !this.products[i].product.name.includes("flexo")
            ) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 1300
              ).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 1900
              ).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (
          this.products[i].group == "condensazione" ||
          this.products[i].group == "tradizionale"
        ) {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(
              2
            );
            var res = (
              parseFloat(price) / parseFloat(kw.replace(",", "."))
            ).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 200
              ).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 180
              ).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].tipologia;
          var superfice = parseFloat(
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].superficielorda.replace(",", ".")
          ).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (
              parseFloat(price) -
              parseFloat(superfice) * 1000
            ).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (
              parseFloat(price) -
              parseFloat(superfice) * 1250
            ).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(
                2
              );
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(
                2
              );
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw) * 1550
              ).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        alert.type = "ERROR";
        this.$store.dispatch(ADD_NOTIFICATIONS, alert);
        this.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text,
        });
      }
    },

    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories() {
      var price = 0;
      if (this.accessories) {
        for (var x in this.accessories) {
          price +=
            this.accessories[x].quantity *
            parseFloat(
              this.accessories[x].price.replace(".", "").replace(",", ".")
            ).toFixed(2);
        }
      } else {
        price = false;
      }

      if (price) {
        this.totalAccessories = numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] =
        this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (
        x != "condensazione" &&
        x != "tradizionale" &&
        x != "pompadicalore" &&
        x != "scaldacqua" &&
        x != "climatizzatore" &&
        x != "solare" &&
        x != "termoregolazione"
      ) {
        var z = {
          index: i,
          name: "",
          serial: "",
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
      this.accessories[i].price = numeral(this.accessories[i].price).format(
        "0.0,[00]"
      );
    },
    setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      // /this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (
        this.ecoBonus == "Ecobonus 50%" ||
        this.ecoBonus == "Bonus Casa 50%"
      ) {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text =
            "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }
      }
    },
    insertAccessoriesCode(input) {
      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on",
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: async (searchItem) => {
          var result = await this.searchAccessories(searchItem, i, input);
          var length = searchItem.length;

          if (length != 10) {
            this.$swal.showValidationMessage(
              `Codice Accessorio ${"deve essere composto da 10 caratteri"}`
            );
            return false;
          }

          if (result) {
            return result;
          } else {
            //throw new Error('Prodotto non trovato')
            this.$swal.showValidationMessage(` ${"Accessorio non trovato"}`);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        this.calcTotalPriceAccessories();
      });
    },
    async searchAccessories(searchItem, index, input) {
      var data = this.allProducts;
      for (var x in data) {
        if (
          x != "condensazione" &&
          x != "tradizionale" &&
          x != "pompadicalore" &&
          x != "scaldacqua" &&
          x != "climatizzatore" &&
          x != "solare"
        ) {
          for (var y in data[x]) {
            if (data[x][y].codice == searchItem) {
              //0010014674
              this.itemsAccessories[input] = this.allProducts[x];
              this.accessories[index].group = x;
              var z = {
                index: y,
                name: data[x][y].Modello,
                serial: data[x][y].codice,
              };
              this.accessories[index].product = z;
              this.accessories[index].quantity = 1;
              //this.accessories[index].price = data[x][y].prezzo

              this.$log(this.accessories);

              return data[x][y];
            }
          }
        }
      }
    },
    mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },

    // NEWWWWWWWWWWWWWWWWWWWWWWWWWWW **************************************** ONLY FOR EDIT

    async setCap(cap) {
      for (var x in this.zips) {
        if (this.zips[x].cap == cap.toUpperCase()) {
          this.zip = this.zips[x].cap;
        }
      }
    },
    async setCity(city) {
      for (var x in this.cities) {
        if (this.cities[x].comune == city.toUpperCase()) {
          var k = {
            cityistat: this.cities[x].istat,
            city: city.toUpperCase(),
          };
          this.city = k;
        }
      }
    },
    async setProvince(province) {
      for (var x in this.provincies) {
        if (this.provincies[x].sigla == province.toUpperCase()) {
          this.province = this.provincies[x].sigla;
        }
      }
    },
    async getInvoiceProducts(code) {
      await axios({
        url: process.env.ROOT_API + "api/getInvoiceProducts",
        method: "POST",
        data: {
          code: code,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          var items = resp.data.products;
          var _vue = this;

          this.$log(items);

          _vue.productIndex = 0;
          _vue.accessoriesIndex = 0;

          var prodCount = 0;
          var accCount = 0;

          for (var x in items) {
            // SET PRODUCTS

            if (items[x].tipo == "product") {
              _vue.addProduct();

              // SET GROUP AND WAIT
              _vue.products[prodCount].index = "product" + prodCount;
              _vue.products[prodCount].indexCount = "quantity" + prodCount;
              _vue.products[prodCount].group = items[x].gruppo;

              _vue.setGroup(_vue.products[prodCount].index);

              // FOR PRELOAD PRODUCTS OF THIS GROUP
              setTimeout(
                function (x, items, Vue, prodCount) {
                  var y = {};

                  /////////////////////////////////////////////////////////////////////////
                  for (var u in _vue.items["product" + prodCount]) {
                    if (_vue.items["product" + prodCount][u]) {
                      if (
                        _vue.items["product" + prodCount][u].Modello ==
                        items[x].nome
                      ) {
                        y.index = parseInt(u);
                      }
                    }
                  }

                  if (!y.index) {
                    y.index = accCount + 100;
                  }
                  //////////////////////////////////////////////////////////////////////////

                  y.name = items[x].nome;
                  y.serial = items[x].codice;
                  //_vue.products[x].product = y
                  _vue.products[prodCount].price = "";
                  _vue.products[prodCount].quantity = 1;

                  setTimeout(
                    function (x, items, Vue, prodCount) {
                      var o = items[x].prezzo.replace(".", "");
                      _vue.products[prodCount].price = o;
                      _vue.products[prodCount].quantity = parseInt(
                        items[x].quantita
                      );
                      _vue.calcTotalPriceProducts();
                    },
                    1000,
                    x,
                    items,
                    Vue,
                    prodCount
                  );

                  _vue.products[prodCount].error = false;

                  _vue.$log(y);

                  var e = _vue.products[prodCount];
                  e.product = y;
                  Vue.set(_vue.products, prodCount, e);

                  _vue.setProduct(_vue.products[prodCount].index);
                },
                1500,
                x,
                items,
                Vue,
                prodCount
              );

              prodCount = prodCount + 1;

              //_vue.productIndex = prodCount
            }
            // SET ACCESORIES
            else {
              _vue.addAccessories();

              // SET GROUP AND WAIT
              _vue.accessories[accCount].index = "product" + accCount;
              _vue.accessories[accCount].indexCount = "quantity" + accCount;
              _vue.accessories[accCount].group = items[x].gruppo;
              _vue.setTypeAccessories(_vue.accessories[accCount].index);

              // FOR PRELOAD PRODUCTS OF THIS GROUP
              setTimeout(
                function (x, items, Vue, accCount) {
                  var y = {};

                  for (var u in _vue.itemsAccessories["product" + accCount]) {
                    if (_vue.itemsAccessories["product" + accCount][u]) {
                      if (
                        _vue.itemsAccessories["product" + accCount][u]
                          .Modello == items[x].nome
                      ) {
                        y.index = parseInt(u);
                      }
                    }
                  }

                  if (!y.index) {
                    y.index = accCount + 100;
                  }

                  y.name = items[x].nome;
                  y.serial = items[x].codice;

                  _vue.accessories[accCount].price = "";
                  _vue.accessories[accCount].quantity = 1;

                  //_vue.products[x].product = y
                  setTimeout(
                    function (x, items, Vue, accCount) {
                      var p = items[x].prezzo.replace(".", "");
                      _vue.accessories[accCount].price = p;
                      _vue.accessories[accCount].quantity = parseInt(
                        items[x].quantita
                      );
                      _vue.calcTotalPriceAccessories();
                    },
                    1000,
                    x,
                    items,
                    Vue,
                    accCount
                  );

                  _vue.accessories[accCount].error = false;

                  var e = _vue.accessories[accCount];
                  e.product = y;
                  Vue.set(_vue.accessories, accCount, e);

                  _vue.setAccessories(_vue.accessories[accCount].index);
                },
                1500,
                x,
                items,
                Vue,
                accCount
              );

              accCount = accCount + 1;

              //_vue.accessoriesIndex = accCount
            }
          }
        })
        .catch((resp) => {});
    },

    calcIvaCustom(val) {
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == "Partita IVA") {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_accessori = parseFloat(0.1).toFixed(2);
        }
      }
    },
  },
  watch: {
    client_type: function (val) {
      this.calcIvaCustom(val);
    },
    usoAbitativo: function (val) {
      this.calcIvaCustom(this.client_type);
    },

    zeroEnea: function (val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    zeroDcast: function (val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function (val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function (val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler(val) {},
      deep: true,
    },
    priceWork: function (val) {
      this.priceWork = val.replace(
        /[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi,
        ""
      );
    },
    clientName: function (val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(
          /[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
          ""
        );
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function (val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(
          /[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
          ""
        );
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function (val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function (val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function (val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function (val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },
    vw: function () {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function (newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios({
          url: process.env.ROOT_API + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.cities = resp.data.cities;
            this.citiesState = false;
          })
          .catch((resp) => {
            this.cities = [];
            this.citiesState = false;
          });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function (newCity) {
      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios({
          url: process.env.ROOT_API + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.zips = resp.data.zips;
            this.zipsState = false;
          })
          .catch((resp) => {
            this.zips = [];
            this.zipsState = false;
          });
      }
    },
  },
  created() {
    this.loadProducts();
  },
  mounted() {
    // NEWWWWWW ***************************************************************
    if (this.$route.params.item) {
      this.item = this.$route.params.item;
      var data = this.item;
      // START POPULATE DATA
      this.$log(data);

      this.ecoBonus = data.bonus;
      // TAB 1 CLIENT
      this.clientLastname = data.client_name;
      this.clientName = data.client_lastname;
      this.adress = data.building_address;
      this.civic = data.building_civic;
      this.email = "";
      this.phone = "";
      this.mobile = "";
      this.provincies = [];
      this.province = "";
      this.provinciesState = true;
      this.cities = [];
      this.citiesState = false;
      this.zips = [];
      this.zipsState = false;
      this.cityError = false;
      this.zipError = false;
      this.city = "";
      this.zip = "";
      this.datiCatastali = parseInt(data.to_get_cadastral_data);

      this.client_mobile = data.client_mobile;
      this.client_phone = data.client_phone;
      this.client_email = data.client_email;
      //TAB2 INTERVENTO
      this.eventType = data.intervention_type;
      this.eventStartdate = data.intervention_date;

      this.totalAccessories = data.total_accessories_price;
      this.totalProducts = data.total_product_price;
      this.enea = parseInt(data.enea_request);
      this.requiredOperations = "";
      this.client_type = data.client_type;
      this.priceEnea = data.client_price_enea ? data.client_price_enea : "0";
      this.priceDcast = "0";

      this.priceWork = data.price_work;

      this.totalExtraMise = 0;
      this.NoEnea = true;

      this.client_ownership = data.client_ownership;

      var _vue = this;
      setTimeout(function () {
        _vue.usoAbitativo = parseInt(data.building_uso_abitativo);
        _vue.iva_altri_oneri = data.iva_altri_oneri;
        _vue.iva_accessori_lavoro = data.iva_accessori_lavoro;
        _vue.iva_age_extra = data.iva_age_extra;
        _vue.iva_age_lavoro = data.iva_age_lavoro;
        _vue.iva_age_accessori = data.iva_age_accessori;
      }, 2000);

      this.$log(" IVAAAAAAAAAAAAAAAAAAAAAAAAAA");
      this.$log(this.iva_altri_oneri);
      this.$log(this.iva_accessori_lavoro);
      this.$log(this.iva_age_extra);
      this.$log(this.iva_age_lavoro);
      this.$log(this.iva_age_accessori);

      //if (data && data.client_type != 'Amministratore di condominio') {
      if (data) {
        setTimeout(async function () {
          var province = _vue.item.building_province;
          await _vue.setProvince(province);

          await _vue.getInvoiceProducts(data.id);

          setTimeout(async function () {
            var city = _vue.item.building_city;
            await _vue.setCity(city);

            setTimeout(async function () {
              var cap = _vue.item.building_zip;
              await _vue.setCap(cap);
            }, 1500);
          }, 1500);
        }, 1500);
      }
    } else {
      this.$router.push("/offerte");
    }

    // ***********************************************************************************************

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart(), // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75,
    });
  },
  computed: {
    ...mapGetters([
      "getNotifications",
      "getProfile",
      "loginerror",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      notifications: (state) => `${state.notifications}`,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/editCalc/index.vue